import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  getFeedbackIssueCategories,
  getFeedbackSuggestionCategories,
} from './actions';
import { FeedbackCategory } from './model';

export interface FeedbackState {
  isFeedbackDialogOpened: boolean;
  feedbackCategories: FeedbackCategory[];
}

const initialState: FeedbackState = {
  isFeedbackDialogOpened: false,
  feedbackCategories: [],
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setFeedbackDialogOpened: (state, action: PayloadAction<boolean>) => {
      state.isFeedbackDialogOpened = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackIssueCategories.fulfilled, (state, action) => {
        state.feedbackCategories = action.payload.map((category) => {
          return { code: category.code, category: category.issuecategory };
        });
      })
      .addCase(getFeedbackSuggestionCategories.fulfilled, (state, action) => {
        state.feedbackCategories = action.payload.map((category) => {
          return { code: category.code, category: category.suggestioncategory };
        });
      });
  },
});

export const { setFeedbackDialogOpened } = feedbackSlice.actions;

export default feedbackSlice.reducer;
